import { render, staticRenderFns } from "./GeneralClientEdit.vue?vue&type=template&id=8379e81c&lang=pug"
import script from "./GeneralClientEdit.vue?vue&type=script&lang=js"
export * from "./GeneralClientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports